<footer>
  <div class="main-footer">
    <div class="links">
      <div class="container footer-wrapper">
        <div class="footer-row">
          <div class="logo-desc">
            <img [src]="storeDetail?.logo" [alt]="storeDetail?.name" />
            
            
            <div class="visa-master">
              <img src="/assets/images/icons/visa-master-2.226fdccdddde.png" alt="" />
            </div>
          </div>
          <div class="nav-links">
            <nav>
              <p class="title">Home</p>
              <a *ngFor="let staticLink of storeDetail?.static_pages"
                [routerLink]="['pages', staticLink.slug]"><span>{{staticLink.title}}</span></a>

            </nav>
          </div>
          <div class="social-media">
            <p class="title">Our Socials</p>
            <a *ngFor="let socialLink of storeDetail?.social_links" target="_blank" href="{{socialLink?.label == 'Email' ? 'mailto://'+socialLink?.address: socialLink?.address}}" (click)="onSocialClick(socialLink)"> <i
                [class]="socialLink?.fontawesome_class"></i><span>{{socialLink.label}}</span></a>
          </div>
        </div>
        <div class="row">
          <div>
            <a [href]="copyrightUrl" class="copy-right">{{copyrightTitle}}</a>
          </div>
          <div class="more-trees">
            <img src="/assets/images/icons/tree.png">
            <p>{{'footer.tree' | translate}}</p>
          </div>
          <div class="visa-master-mobile">
            <img src="/assets/images/icons/visa-master-2.226fdccdddde.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>